import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const PattiItemWise = ({ includeYearCode = true }) => {
   const apiUrl = `${process.env.REACT_APP_API}/getdata-ItemWise`;
   const columns = [
      { label: "Item Code", key: "Item_Code" },
      { label: "Item Name", key: "System_Name_E" },
      { label: "Effective Date", key: "Eff_Date" },
      { label: "Market Cess", key: "Market_Cess" },
      { label: "Dekrekh", key: "Dekrekh" },
      { label: "Hamali on", key: "Hamali_on" },
      { label: "Tolad on", key: "Tolad_on" },
      { label: "Levi Rate", key: "Levi_rate" },
      { label: "Hamali Rate", key: "Hamali_rate" },
      { label: "Tolai Rate", key: "Tolai_rate" },
      { label: "Container", key: "Container" },
   ];
   return (
      <TableUtility
         title="Item Wise Cess"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/item_wise_cess"
         detailUrl="/item_wise_cess"
         permissionUrl="/item_wise_cess_utility"
         includeYearCode={includeYearCode}

      />
   );

};

export default PattiItemWise;